import VueRouter from "vue-router";
import ProductTable from "../components/product/ProductTable";
import ProductNotSync from "../components/product/ProductNotSync";
import Page from "../components/Page";
import LoginForm from "../components/auth/LoginForm";
import EmailForm from "../components/auth/EmailForm";
import ResetPasswordForm from "../components/auth/ResetPasswordForm";
import ChangePasswordForm from "../components/user/ChangePasswordForm";
import ProductForm from "../components/product/ProductForm";
import ProductMassAction from "../components/product/ProductMassAction";
import ProductMassDiscount from "../components/product/ProductMassDiscount";
import UnauthorizedPage from "../components/page/UnauthorizedPage";
import app from '../app.js'
import ProductMassCategoryAction from "../components/product/massActions/ProductMassCategoryAction";

 const router = new VueRouter(
    {
        routes: [
            {
                name: 'auth.login',
                path: '/login',
                component: LoginForm,
                meta: {
                    auth: true,
                    public: true
                }
            },
            {
                name: 'auth.reset-password',
                path: '/reset-password',
                component: EmailForm,
                meta: {
                    auth: true,
                    public: true
                }
            },
            {
                name: 'auth.reset-password.token',
                path: '/reset-password/:token',
                component: ResetPasswordForm,
                meta: {
                    auth: true,
                    public: true
                }
            },
            {
                name: 'home',
                path: '/',
                component: ProductTable,
                meta: {
                    public: false
                }
            },
            {
                name: 'product.index',
                path: '/product/index',
                component: ProductTable,
                beforeEnter(to, from, next) {
                    app.isAuthorizedWithRedirect('product', 'show')
                        .then(() => {next()});
                }
            },
            {
                name: 'product.edit',
                path: '/product/edit/:id',
                component: ProductForm,
                beforeEnter(to, from, next) {
                    app.isAuthorizedWithRedirect('product', 'edit')
                        .then(() => {next()});
                }
            },
            {
                name: 'product.edit.store',
                path: '/product/edit/:id/store/:store',
                component: ProductForm,
                beforeEnter(to, from, next) {
                    app.isAuthorizedWithRedirect('product', 'edit')
                        .then(() => {next()});
                }
            },
            {
                name: 'product.mass.update',
                path: '/product/mass/update',
                component: ProductMassAction,
                beforeEnter(to, from, next) {
                    app.isAuthorizedWithRedirect('product', 'edit')
                        .then(() => {next()});
                }
            },
            {
                name: 'product.mass.category',
                path: '/product/mass/category',
                component: ProductMassCategoryAction,
                beforeEnter(to, from, next) {
                    app.isAuthorizedWithRedirect('product', 'edit')
                        .then(() => {next()});
                }
            },
            {
                name: 'product.notsync',
                path: '/product/notsync',
                component: ProductNotSync,
                beforeEnter(to, from, next) {
                    app.isAuthorizedWithRedirect('product', 'show')
                        .then(() => {next()});
                }
            },
            {
                name: 'sales.discount.planner',
                path: '/sales/discount/planner',
                component: ProductMassDiscount
            },
            {
                name: 'user.change-password',
                path: '/profile/change-password',
                component: ChangePasswordForm
            },
            {
                name: 'model.action',
                path: '/:resource/:action/:routeKey?',
                component: Page,
                beforeEnter(to, from, next) {
                    app.isAuthorizedWithRedirect(to.params.resource, to.params.action)
                        .then(() => next());
                }
            },
            {
                name: 'unauthorized',
                path: '/action-forbidden',
                component: UnauthorizedPage
            }
        ],
        mode: 'history'
    }
)


// check if user is logged in
router.beforeEach((to, from, next) => {
    const isLoggin = to.name === 'auth.login';
    if (to.meta.hasOwnProperty('public') && to.meta.public && !isLoggin) {
        next();
        return;
    }

    // TODO (marco) add check if user is authorized to take action
    window.axios.get('/user/check')
        .then(response => {
            if (response.data.loggedIn) {
                if (isLoggin) {
                    next({name: 'home'});
                    return;
                }
                next();
            } else {
                if (isLoggin) next()
                else next({name: 'auth.login'})
            }
        })
        // TODO (marco) manage error message
        .catch(respone => {
            if (isLoggin) next()
            else next({name: 'auth.login'});
        })
})

export default router;
